import { useEffect, useRef } from "react";
import { useLocation } from "wouter";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import staioIcon from "@/assets/images/staio-icon.png";

export default function CheckoutSuccessPage() {
  const [, setLocation] = useLocation();
  const queryClient = useQueryClient();
  const verified = useRef(false);

  useEffect(() => {
    if (verified.current) return;
    verified.current = true;

    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");

    const activate = async () => {
      if (sessionId) {
        try {
          await apiRequest("GET", `/api/stripe/verify-checkout?session_id=${encodeURIComponent(sessionId)}`);
        } catch (err) {
          console.error("[checkout-success] verify-checkout error:", err);
        }
      }
      queryClient.invalidateQueries({ queryKey: ["/api/user"] });
      setTimeout(() => setLocation("/admin"), 2500);
    };

    activate();
  }, [queryClient, setLocation]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-6 p-4"
      style={{ background: "linear-gradient(135deg, hsl(30 33% 98%) 0%, hsl(35 40% 95%) 50%, hsl(25 30% 94%) 100%)" }}
    >
      <img src={staioIcon} alt="Staio" className="w-16 h-16" />
      <div className="text-center space-y-2">
        <CheckCircle2 className="w-12 h-12 mx-auto text-green-500" />
        <h1 className="text-2xl font-display font-bold text-foreground">You're all set!</h1>
        <p className="text-muted-foreground">
          Your Staio subscription is active. Your 7-day free trial has started.
        </p>
        <p className="text-sm text-muted-foreground mt-4">Redirecting to your dashboard...</p>
      </div>
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  );
}
